import Modal from './Modal';
import Ayuda from './Ayuda';
import { useNavegacion } from './navegacionReact';

// «¿SALIR SIN GUARDAR?» · TC-DR-AT. Cuando atrás (o un cambio de módulo)
// abandonaría una pantalla con trabajo sin guardar, el módulo de
// navegación se detiene y pregunta aquí. Nunca se pierde nada en silencio.
//
// Se monta UNA vez en `App.jsx`: sirve al acceso, al alta y a la
// aplicación. No ocupa entrada en el historial (`capa={false}`): pulsar
// atrás con el diálogo abierto equivale a «Quedarme», y eso lo resuelve
// el propio módulo.
//
// El botón primario es «Quedarme», en el sitio del primario de siempre
// (a la derecha): lo que se hace sin pensar tiene que ser lo que no
// pierde nada.
//
// LOS DOS BOTONES MIDEN 44 px DE ALTO (`min-h-11`) y van separados 12 px:
// son los que deciden si se abandona una venta, y se pulsan con el pulgar.
// El auditor los midió en 36 y 38 px (nota H5, 4 oct 2026).
//
// LA AYUDA NO DICE QUÉ PASA CON LO CAPTURADO: eso lo dice el párrafo de
// arriba, que cada pantalla escribe con su regla («queda guardada en este
// dispositivo», «no se vuelven a mostrar»). Antes la ayuda afirmaba «sin
// guardar lo que cambiaste» debajo de una venta que sí se conserva.
export const TEXTO_POR_OMISION = 'Esta pantalla tiene cambios sin guardar. Si sales ahora, se pierden.';

export default function DialogoSalirSinGuardar() {
  const { confirmacion, responder } = useNavegacion();
  if (!confirmacion) return null;
  return (
    <Modal
      titulo="¿Salir sin guardar?"
      onCerrar={() => responder(false)}
      capa={false}
      guardia={false}
      pie={
        <div className="flex items-center justify-end gap-3 p-4 border-t border-gray-200 flex-wrap">
          <button
            type="button"
            onClick={() => responder(true)}
            className="inline-flex min-h-11 min-w-11 items-center justify-center text-sm font-semibold px-4 py-2 rounded-lg border border-gray-300 bg-white text-gray-700 hover:bg-gray-50"
          >
            Salir
          </button>
          <button
            type="button"
            onClick={() => responder(false)}
            autoFocus
            className="inline-flex min-h-11 min-w-11 items-center justify-center text-sm font-semibold px-4 py-2 rounded-lg text-white bg-[var(--color-marca)] hover:bg-[var(--color-marca-fuerte)]"
          >
            Quedarme
          </button>
        </div>
      }
    >
      <p className="text-sm text-gray-600">{confirmacion.detalle || TEXTO_POR_OMISION}</p>
      <Ayuda id="navegacion.salir_sin_guardar" />
    </Modal>
  );
}
